import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./index.css";
import PatsForm from "./patsForm";
import GifDemo from "./gifDemo";
//import DraftDemo from './draftjsDemo';
//import PatsPosts from './patsPosts';
import PostItem from "./patsPosts_item";
import InfiniteScroll from "react-infinite-scroll-component";
//React alert
import { useAlert } from "react-alert";

//Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import "swiper/components/navigation/navigation.min.css";
// import Swiper core and required modules
import SwiperCore, { Pagination, Navigation } from "swiper/core";

//#region Images
import sun from "../../assets/images/sun.png";
import evening from "../../assets/images/sunset.png";
import moon from "../../assets/images/moon.png";
import tt_question from "../../assets/images/tt_question.png";

import ellipsis from "../../assets/images/ellipsis.png";
import bdg_teamplayer from "../../assets/images/bdg_teamplayer.png";
import bdg_innovator from "../../assets/images/bdg_innovator.png";
import like_blue2 from "../../assets/images/like_blue2.png";
import like from "../../assets/images/like.png";
import comment from "../../assets/images/comment.png";

import star from "../../assets/images/star.png";
import gift from "../../assets/images/gift.png";
import play from "../../assets/images/play.png";
import logo from "../../assets/images/i2econsulting-logo.png";

import arrowLeft from "../../assets/images/arrow_left.png";
import arrowRight from "../../assets/images/arrow_right.png";
import arrowTop from "../../assets/images/arrow_top.png";
import arrowBottom from "../../assets/images/arrow_bottom.png";
import $ from "jquery";
// install Swiper modules
SwiperCore.use([Pagination, Navigation]);
//#endregion Images

function Home() {
  const alert = useAlert();
  const [items, setItems] = useState([]);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [more, setMore] = useState(true);

  const [monthlyPats, setMonthlyPats] = useState(0);
  const [earnedPats, setEarnedPats] = useState(0);

  //Hook to rerender when new post is added
  const [refresh, setRefresh] = useState(0);

  const [badgesCv, setBadges] = useState([]);
  const [newBadgesCv, setNewBadges] = useState([]);
  const [userName, setUserName] = useState("");
  const FirstName = userName.split(" ");
  const [greetingMsg, setGreetingMsg] = useState("");
  const [greetingImg, setGreetingImg] = useState("");


  useEffect(() => {


    fetch(process.env.REACT_APP_API_URL + "api/posts/hashtag")
      .then((response) => response.json())
      .then((data) => {
        setBadges(data);

        //Get username and image from localstorage
        if (localStorage.getItem("pats_login") !== null) {
          var pats_login = JSON.parse(localStorage.getItem("pats_login"));
          setUserName(pats_login.userName);
          // if(pats_login.userImage !== null && pats_login.userImage !== ''){
          //   setUserImage(pats_login.userImage);
          // }
        }
        greetings();
      });
  }, []);

  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL + "api/posts/newhashtag")
      .then((response) => response.json())
      .then((data) => {
        setNewBadges(data);

      });
  }, []);

  //#region Feed, Lazy load
  useEffect(() => {
    //Get Monthly pats and Earned pats on load.
    fetch(process.env.REACT_APP_API_URL + "api/user/pats")
      .then((response) => response.json())
      .then((data) => {
        if (data.issuccessful == true) {
          setMonthlyPats(data.pats.monthlyPats);
          setEarnedPats(data.pats.earnedPats);
        }
      });

    setItems([]);
    fetchInitialData();
  }, [refresh]);

  // useEffect(() => {
  //   fetchInitialData();

  //   const interval = setInterval(() => {
  //     fetchInitialData();

  //   }, 10000);
  //   return () => clearInterval(interval);
  // }, []);

  const fetchInitialData = () => {
    fetch(process.env.REACT_APP_API_URL + "api/posts/" + limit + "/0")
      .then((response) => response.json())
      .then((data) => {
        if (data.issuccessful == true) {
          setItems(data.posts);
          setOffset(limit);
        } else {
          alert.error(data.message);
        }
      });
  };

  const fetchMoreData = () => {

    fetch(process.env.REACT_APP_API_URL + "api/posts/" + limit + "/" + offset)
      .then((response) => response.json())
      .then((data) => {
        if (data.issuccessful == true) {
          setItems(items.concat(data.posts));
          if (data.posts.length < limit) {
            setMore(false);
          } else {
            setOffset(offset + limit);
          }
        } else {
          alert.error(data.message);
        }
      });
  };
  //#endregion

  const BadgesSliderCv = () => {
    var showBadges = false;
    // var badgesCvWithImage = badgesCv.filter((badge, index) => {
    //   return badge.avatar !== null && badge.avatar !== "";
    // });
    var badgesCvWithImage = badgesCv;
    if (badgesCvWithImage.length > 0) {
      showBadges = true;
    }

    if (showBadges) {
      return (
        <div className="cv-slider-wrap">
          <Swiper
            slidesPerView={2}
            spaceBetween={5}
            navigation={(true, { nextEl: ".cv-next", prevEl: ".cv-prev" })}
            className="cv-slider"
          >
            {badgesCvWithImage.map((badge, index) => {
              return (
                <SwiperSlide key={index}>
                  <div className="cv-item">
                    <div className="cv-img">
                      <img src={badge.avatar} alt="" />
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
          <img src={arrowRight} className={"cv-arrow cv-next"} alt="next" />
          <img src={arrowLeft} className={"cv-arrow cv-prev"} alt="prev" />
        </div>
      );
    } else {
      return <div className="cv-slider-wrap"></div>;
    }
  };

  const NewBadgesSlider = () => {
    var showBadges = false;
    // var badgesCvWithImage = badgesCv.filter((badge, index) => {
    //   return badge.avatar !== null && badge.avatar !== "";
    // });
    var badgesWithImage = newBadgesCv;
    if (badgesWithImage.length > 0) {
      showBadges = true;
    }

    if (showBadges) {
      return (
        <div className="cv-slider-wrap">
          <Swiper
            slidesPerView={2}
            spaceBetween={5}
            navigation={(true, { nextEl: ".ncv-next", prevEl: ".ncv-prev" })}
            className="cv-slider"
          >
            {badgesWithImage.map((badge, index) => {
              return (
                <SwiperSlide key={index}>
                  <div className="cv-item">
                    <div className="cv-img">
                      <img src={badge.avatar} alt="" />
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
          <img src={arrowRight} className={"cv-arrow ncv-next"} alt="next" />
          <img src={arrowLeft} className={"cv-arrow ncv-prev"} alt="prev" />
        </div>
      );
    } else {
      return <div className="cv-slider-wrap"></div>;
    }
  };
  function greetings() {
    var greetingDate = new Date();
    var greetingHour = greetingDate.getHours();
    // var greetingHour = 5;

    if (greetingHour < 12) {
      setGreetingMsg("Good Morning");
      setGreetingImg(sun);
    } else if (greetingHour < 17) {
      setGreetingMsg("Good Afternoon");
      setGreetingImg(sun);
    } else if (greetingHour < 18) {
      setGreetingMsg("Good Evening");
      setGreetingImg(evening);
    } else {
      setGreetingMsg("Good Evening");
      setGreetingImg(moon);
    }
  }


  return (
    <section>
      <div className="row">
        <div className="col-lg-4 col-md-4 order-md-12">
          {/*Earned pats[ep]*/}
          <div className="ep-wrap">
            <div className="ep-card">
              <div className="ep-pats-wrap">
                <div className="ep-pats-border">
                  <div className="ep-pats">
                    <p>
                      <span>{earnedPats}</span>{" "}
                      {earnedPats == 1 ? "Pat" : "Pats"}
                    </p>
                  </div>
                </div>
              </div>
              <p className="ep-text">
                You have {earnedPats} {earnedPats == 1 ? "Pat" : "Pats"} to
                redeem!
              </p>
              <Link to="/rewards" className="ep-btn blue-btn">
                <img src={star} alt="" />
                <span>Pick a reward</span>
              </Link>
              {/* <Link to="/rewards" className="ep-gift">
                or give a{" "}
                <span>
                  gift <img src={gift} alt="" />
                </span>
              </Link> */}
            </div>
          </div>
          {/*Earned pats[ep]-----END*/}

          {/*How does this work[hd]*/}
          {/* <div className="hd-wrap">
            <h5 className="hd-title">How does this work?</h5>
            <div className="hd-video">
              <img src={play} alt="" />
            </div>
          </div> */}
          {/*How does this work[hd]-----END*/}

          {/*P2P works[pw]*/}
          <div className="pw-wrap">
            <div className="pw-card">
              <div className="pw-slider-wrap">
                <Swiper
                  // pagination={true}
                  pagination={{ clickable: true }}
                  autoHeight={true}
                  className="pw-slider"
                >
                  <SwiperSlide>
                    <div className="pw-item">
                      <h5 className="pw-title">How Pats! works?</h5>
                      <p className="pw-text">
                        Pats! is a unique peer-to-peer recognition platform
                        where you can appreciate your colleagues and give them a
                        token of reward.
                      </p>
                      {/* <p className="pw-author">
                        Lynda, Senior vice president of i2e consulting
                      </p>
                      <div className="pw-logo">
                        <img src={logo} alt="" />
                      </div> */}
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="pw-item">
                      <h5 className="pw-title">How Pats! works?</h5>
                      <p className="pw-text">
                        Every month each one of us will receive 100 pats, and we
                        all can reward each other these 'pats' ranging from one
                        to 100 as a token of appreciation for a job well done.
                        You can also give badges to recognize their unique
                        talent or effort.
                      </p>
                      {/* <p className="pw-author">
                        Lynda, Senior vice president of i2e consulting
                      </p>
                      <div className="pw-logo">
                        <img src={logo} alt="" />
                      </div> */}
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="pw-item">
                      <h5 className="pw-title">Wait! There is more!</h5>
                      <p className="pw-text">
                        One 'pat' is equivalent to one rupee, so you can use the
                        pats you receive to unlock exciting offers and redeem
                        your well-deserved reward.
                      </p>
                      {/* <p className="pw-author">
                        Lynda, Senior vice president of i2e consulting
                      </p>
                      <div className="pw-logo">
                        <img src={logo} alt="" />
                      </div> */}
                    </div>
                  </SwiperSlide>
                </Swiper>
                {/* <div className="pw-item">
                  <h5 className="pw-title">Peer-to-peer recognition works</h5>
                  <p className="pw-text">"Lorem ipsum dolor sit amet consectetur adipisicing elit. Perferendis omnis, officia excepturi qui incidunt sequi ipsa tempore, dolorum ut neque exercitationem, voluptate blanditiis delectus. Eaque. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Suscipit, eos."</p>
                  <p className="pw-author">
                    Lynda, Senior vice president of i2e consulting
                      </p>
                  <div className="pw-logo">
                    <img src={logo} alt="" />
                  </div>
                </div> */}
              </div>
              {/* <div className="pw-dots"></div> */}
            </div>
          </div>
          {/*P2P works[pw]-----END*/}

          {/*Company value badges[cv]*/}
          <div className="cv-wrap">
            <div className="tt-title cv-title">
              <h5>Company Value Badges</h5>
              <div className="tt-icon">
                <img src={tt_question} alt="tooltip" />
                <div className="tt-text tt-text-left">
                  <p>
                    Every month you get 100 Pats to give away to your colleagues.
                    Pats that are not used today will not add up with the 100
                    Pats that you will get tomorrow.
                  </p>
                </div>
              </div>
            </div>
            <BadgesSliderCv />
            {/* <div className="cv-slider-wrap">
              <Swiper slidesPerView={2} spaceBetween={5} navigation={true,{nextEl: '.cv-next', prevEl: '.cv-prev'}} className="cv-slider">
                <SwiperSlide>
                <div className="cv-item">
                  <div className="cv-img">
                    <img src={bdg_teamplayer} alt="" />
                  </div>
                </div>
                </SwiperSlide>
                <SwiperSlide>
                <div className="cv-item">
                  <div className="cv-img">
                    <img src={bdg_teamplayer} alt="" />
                  </div>
                </div>
                </SwiperSlide>
                <SwiperSlide>
                <div className="cv-item">
                  <div className="cv-img">
                    <img src={bdg_teamplayer} alt="" />
                  </div>
                </div>
                </SwiperSlide>
              </Swiper> */}
            {/* <div className="cv-item">
                <div className="cv-img">
                  <img src={bdg_teamplayer} alt="" />
                </div>
              </div>
              <div className="cv-item">
                <div className="cv-img">
                  <img src={bdg_innovator} alt="" />
                </div>
              </div> */}

            {/* <div className="cv-arrow cv-next">
                <img src={arrowRight} alt="next" />
              </div>
              <div className="cv-arrow cv-prev">
                <img src={arrowLeft} alt="prev" />
              </div>
            </div> */}
          </div>
          <br />
          <div className="cv-wrap">
            <div className="tt-title cv-title">
              <h5>Newly Added Badges</h5>
              <div className="tt-icon">
                {/* <img src={tt_question} alt="tooltip" /> */}
                <div className="tt-text tt-text-left">
                </div>
              </div>
            </div>
            <NewBadgesSlider />
            {/* <div className="cv-slider-wrap">
              <Swiper slidesPerView={2} spaceBetween={5} navigation={true,{nextEl: '.cv-next', prevEl: '.cv-prev'}} className="cv-slider">
                <SwiperSlide>
                <div className="cv-item">
                  <div className="cv-img">
                    <img src={bdg_teamplayer} alt="" />
                  </div>
                </div>
                </SwiperSlide>
                <SwiperSlide>
                <div className="cv-item">
                  <div className="cv-img">
                    <img src={bdg_teamplayer} alt="" />
                  </div>
                </div>
                </SwiperSlide>
                <SwiperSlide>
                <div className="cv-item">
                  <div className="cv-img">
                    <img src={bdg_teamplayer} alt="" />
                  </div>
                </div>
                </SwiperSlide>
              </Swiper> */}
            {/* <div className="cv-item">
                <div className="cv-img">
                  <img src={bdg_teamplayer} alt="" />
                </div>
              </div>
              <div className="cv-item">
                <div className="cv-img">
                  <img src={bdg_innovator} alt="" />
                </div>
              </div> */}

            {/* <div className="cv-arrow cv-next">
                <img src={arrowRight} alt="next" />
              </div>
              <div className="cv-arrow cv-prev">
                <img src={arrowLeft} alt="prev" />
              </div>
            </div> */}
          </div>
          {/*Company value badges[cv]-----END*/}
        </div>
        <div className="col-lg-8 col-md-8 order-md-1">
          {/*Page title[pt]*/}
          <div className="tt-title-wrap">
            <div className="pt-flex">
              <div className="pt-img">
                <img src={greetingImg} alt="sun" />
              </div>
              <div className="pt-text">
                <h3>
                  {greetingMsg}, {FirstName[0]}!
                </h3>
              </div>
            </div>
            <div className="tt-title">
              <h1>
                You have{" "}
                <span>
                  {monthlyPats} {monthlyPats < 2 ? "Pat" : "Pats"}
                </span>{" "}
                to give away!
              </h1>
              <div className="tt-icon">
                <img src={tt_question} alt="tooltip" />
                <div className="tt-text">
                  <p>
                    Every month you get 100 Pats to give away to your colleagues.
                    Pats that are not used in current will not add up with the
                    100 pats that you will get in next month.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/*Page title[pt]-----END*/}

          {/*Pats Form[pf]*/}
          <PatsForm refresh={refresh} setRefresh={setRefresh} fetchInitialData={fetchInitialData} />
          {/*<GifDemo refresh={refresh} setRefresh={setRefresh} />*/}
          {/*Pats Form[pf]-----END*/}

          {/*Pats Posts[pp]*/}
          <div className="pp-wrap">
            <InfiniteScroll
              dataLength={items.length}
              next={fetchMoreData}
              hasMore={more}
              loader={<h4>Loading...</h4>}
              refreshFunction={fetchInitialData}
            >
              {items.map((element, index) => (
                <>
                  <PostItem data={element} key={index} setMonthlyPats={setMonthlyPats} />
                </>
              ))}
            </InfiniteScroll>
          </div>
          {/*Pats Posts[pp]-----END*/}
        </div>

      </div>
    </section>
  );
}

export default Home;
